'use strict';

var React = require('react');
var svtdestinations = require('../../utils/destinations');

class DestinationText extends React.Component {

	_isValidDestination(destination) {
		return destination && svtdestinations[destination];
	}

	render() {
		var destination = this.props.destination;

		if (!this._isValidDestination(destination)) {
			return false;
		}

		var fullDestination = svtdestinations[destination].name;

		return (
			<span>{fullDestination}</span>
		);
	}
}
DestinationText.displayName = 'DestinationText';
DestinationText.propTypes = {
	destination: React.PropTypes.string
};


module.exports = DestinationText;



/** WEBPACK FOOTER **
 ** ./app/components/Teaser/DestinationText.jsx
 **/